import { useEffect, useState } from "react";
import Button from "@/components/base/Button";
import { MAPS_LINK, PHONE_TEL } from "@/pages/home/constants";

export default function MobileBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      const nearBottom = y + window.innerHeight > pageHeight - 260;
      setVisible(y > 520 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 px-3 pb-3 pt-2 transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full pointer-events-none"
      }`}
    >
      <div className="flex gap-2">
        <Button
          href={MAPS_LINK}
          variant="primary"
          external
          fbEvent="FindLocation"
          fbLabel="body_mobile"
          className="flex-1"
        >
          <i className="ri-map-pin-2-line text-base" aria-hidden="true"></i>
          Cómo llegar
        </Button>
        <Button href={PHONE_TEL} variant="outline" className="flex-1">
          <i className="ri-phone-line text-base" aria-hidden="true"></i>
          Llamar
        </Button>
      </div>
    </div>
  );
}